// extracted by mini-css-extract-plugin
module.exports = {"container":"e-commerce-item_container__zcD5u","image":"e-commerce-item_image__qcaYa"};